import { render, staticRenderFns } from "./PopUpWarning.vue?vue&type=template&id=a4a49662&scoped=true&"
import script from "./PopUpWarning.vue?vue&type=script&lang=js&"
export * from "./PopUpWarning.vue?vue&type=script&lang=js&"
import style0 from "./PopUpWarning.vue?vue&type=style&index=0&id=a4a49662&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a49662",
  null
  
)

export default component.exports